document.addEventListener('alpine:init', () => {
  Alpine.data('portfolio', () => ({
    activeCategory: 'All',
    isExpanded: false,
    totalItems: 0,

    init() {
      this.$nextTick(() => {
        this.totalItems = this.$el?.querySelectorAll?.('.portfolio__card')?.length || 0;
        this.initSwipers();
      });
    },

    setCategory(category) {
      this.activeCategory = category;
      this.isExpanded = category !== 'All';
    },

    initSwipers() {
      if (!window.Swiper) return;
      const nodes = this.$el?.querySelectorAll?.('[data-portfolio-swiper]') || [];
      nodes.forEach((node) => {
        if (node.dataset.swiperInitialized === 'true') return;
        // eslint-disable-next-line no-new
        new window.Swiper(node, {
          slidesPerView: 1,
          spaceBetween: 12,
          loop: false,
          pagination: {
            el: node.querySelector('.swiper-pagination'),
            clickable: true,
          },
          navigation: {
            nextEl: node.querySelector('.swiper-button-next'),
            prevEl: node.querySelector('.swiper-button-prev'),
          },
        });
        node.dataset.swiperInitialized = 'true';
      });
    },

    isVisible(rawCategories) {
      if (this.activeCategory === 'All') return true;
      if (!rawCategories) return false;
      const categories = rawCategories
        .split('||')
        .map((cat) => cat.trim())
        .filter(Boolean);
      return categories.includes(this.activeCategory);
    },

    loadMore() {
      this.isExpanded = true;
    },

    canLoadMore() {
      if (this.activeCategory !== 'All') return false;
      if (this.isExpanded) return false;
      return this.totalItems > 4;
    },
  }));
});
